import { combineReducers, configureStore } from "@reduxjs/toolkit";
import allReducers from "../../reducers/Index/reducer";
import { isServer } from "../../utils/environmentDetection/library";
import { sentryReduxMiddleware } from "../../utils/sentry/sentryReduxMiddleware";

const loggerEnabled =
    process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test";

export const loggerMiddleware = () => (next) => (action) => {
    if (loggerEnabled) console.log("->", action.type);
    return next(action);
};

// Default middleware options for configureStore from @reduxjs/toolkit
export const defaultMiddlewareOptions = {
    serializableCheck: {
        warnAfter: 3000, // time in ms before warning that serializableCheck is taking too long
    },
    immutableCheck: {
        warnAfter: 3000, // time in ms before warning that immutableCheck is taking too long
    },
};

export const createStore = (
    initialState = { fixed: { year: new Date().getFullYear() } }
) => {
    const store = configureStore({
        reducer: allReducers,
        middleware: (getDefaultMiddleware) => {
            const middlewares = getDefaultMiddleware(defaultMiddlewareOptions);

            if (isServer()) {
                return middlewares.concat(loggerMiddleware);
            } else {
                return middlewares.concat(sentryReduxMiddleware);
            }
        },
        preloadedState: initialState,
    });
    // Add a dictionary to keep track of the registered async reducers
    store.asyncReducers = {};

    // Create an inject reducer function
    // This function adds the async reducer, and creates a new combined reducer
    store.injectReducer = (key, asyncReducer) => {
        if (!store.asyncReducers[key]) {
            store.asyncReducers[key] = asyncReducer;
            store.replaceReducer(createReducer(store.asyncReducers));
        }
    };

    return store;
};

function createReducer(asyncReducers) {
    return combineReducers({
        ...allReducers,
        ...asyncReducers,
    });
}
